import ProfileSearchService from "@services/profile-search-service";
import { getSingleInstanceByElement, getSingleInstanceByName } from "../../../core";
import BinderAutocomplete from "../../binder/binder-autocomplete";
import Component from "../../component.abstract"
import { notifyFromAlert } from "../../helpers/notifs";
import SimpleProgress from "../../simple-progress/simple-progress";
import ProfileInformations from "../informations/profile-informations";
import { SearchDataFields } from "./search-data-fields";

interface ProfileSearchProps {
    url: string;
}

export default class ProfileSearch extends Component {
    private saveButton: HTMLElement;
    private profileInformations:ProfileInformations;
    private jobBinder: BinderAutocomplete; 
    private localityBinder: BinderAutocomplete; 
    private contractsContainer: HTMLElement;
    private data: any;
    private previousData: SearchDataFields;
    private url:string;

    constructor(
        private props: ProfileSearchProps,
        element:HTMLElement
    ) { 
        super(props, element)
        this.url = this.props.url;
    }

    mounted():void {
        this.injectTemplate();

        this.profileInformations = getSingleInstanceByName("ProfileInformations");

        this.saveButton = this.element.querySelector(".profile-form-save");

        this.jobBinder = getSingleInstanceByElement("BinderAutocomplete", this.element.querySelector("[data-binder-autocomplete][data-name=job]"));
        this.localityBinder = getSingleInstanceByElement("BinderAutocomplete", this.element.querySelector("[data-binder-autocomplete][data-name=locality]"));
        this.contractsContainer = this.element.querySelector(".contracts-container");
        if (this.url) {
            this.call();
            this.saveButton.addEventListener("click", () => {
                this.save();
            });
        }
    }
    setUrl(newurl:string):void {
        this.url = newurl;
    }
    getUrl():string {
        return this.url;
    }
    call():void {
        const service = new ProfileSearchService(this.url);

        service.setErrorHandler((error:any) => {
            let message: string;
            if(error?.Message) {
                message = error.Message;
            }
            this.displayError(message)
        });

        service.get((response:any) => {
             try {
                    this.data = response;
                    this.setFields();
                } catch(e) {
                    this.displayError();
                }
                //Add tracking event on load
                if (this.data.trackingsLoad && this.data.trackingsLoad.length) {
                   const trackingsLoad = this.data.trackingsLoad[0];
                   window.dataLayer.push(trackingsLoad)
                }
        });
    }
    displayError(message?: string):void {
        notifyFromAlert({
            "Icon": 2,
            "Message": message ? message : "Aïe, une erreur est survenue, rechargez la page et réessayez.",
            "AnalyticsTrackings": "",
            "sticky": true
        }, true);
    }
    setFields():void {
        this.jobBinder.clear();
        if (this.data.jobs) {
            for (let i = 0; i < this.data.jobs.length; i++) {
                const job = this.data.jobs[i];
                this.jobBinder.addValue(undefined,{
                    "element": {
                        "value": job.label
                    }, 
                    "autocompleteinput": {
                        "value": job.uri
                    }
                });
            }
        }
        this.localityBinder.clear();
        if (this.data.locations) {
            for (let i = 0; i < this.data.locations.length; i++) {
                const location = this.data.locations[i];
                this.localityBinder.addValue(undefined,{
                    "element": {
                        "value": location.label
                    }, 
                    "autocompleteinput": {
                        "value": location.uri
                    }
                });
            }
        }
        this.contractsContainer.innerHTML = "";
        if (this.data.contractTypes) {
            // Add the contract checkboxes to the DOM
            for (let i = 0; i < this.data.contractTypes.length; i++) {
                const contract = this.data.contractTypes[i];

                const input = document.createElement("input");
                input.setAttribute("type", "checkbox");
                input.setAttribute("contracts", "checkbox");
                input.setAttribute("id", contract.uri);
                input.checked = !!contract.selected;

                const label = document.createElement("label");
                label.setAttribute("for", contract.uri);
                label.innerText = contract.label;

                this.contractsContainer.appendChild(input);
                this.contractsContainer.appendChild(label);
            }
        }

        this.previousData = this.getFields();
        this.element.classList.remove('pending');
    }
    getFields(): SearchDataFields {
        const contractTypes = [];
        const contracts = this.contractsContainer.querySelectorAll("input[type=checkbox]:checked");
         for (let i = 0; i < contracts.length; i++) {
            contractTypes.push({
                "label": this.contractsContainer.querySelector<HTMLElement>("label[for='" + contracts[i].getAttribute("id") +"']").innerText,
                "uri": contracts[i].getAttribute("id")
            });
        }
        const dataFields = new SearchDataFields () 
        dataFields.jobs = this.jobBinder.getCriterionFormatValue();
        dataFields.locations = this.localityBinder.getCriterionFormatValue();
        dataFields.contractTypes = contractTypes
        return dataFields;
    }
    save():void {
        const data = this.getFields();
        const isValid = data.checkValidity();
        if (!isValid) {
            return this.displayError(data.getError());
        }
        this.saveButton.classList.add("disabled");
        const progressButtonInstance: SimpleProgress = getSingleInstanceByElement("SimpleProgress", this.saveButton)
        progressButtonInstance.start();

        const service = new ProfileSearchService(this.url);

        service.setErrorHandler((error:any) => {
            let message: string;
            if(error?.Message) {
                message = error.Message;
            }
            this.displayError(message)
            this.saveButton.classList.remove("disabled");
            progressButtonInstance.stop();
        });

        service.post(data, (response:any) => {
            this.previousData = data;
            this.profileInformations.setData(response.infosProfil);
            this.profileInformations.displayResults();
            this.profileInformations.initSearchLabels();
            this.profileInformations.setCompletion();
            //Add tracking event on save search and check if save on popin before
            const popin = document.querySelectorAll(".hasOk")
            const notifValid = document.querySelectorAll("data-notification")
            if (popin.length < 1 && notifValid.length < 1) {
                window.dataLayer.push(this.data.trackingsClick[0])
            }
            notifyFromAlert({
                "Icon": 0,
                "Message": response.message,
                "AnalyticsTrackings": "",
                "sticky": true,
                "vanish": true
            }, true);
            this.saveButton.classList.remove("disabled");
            progressButtonInstance.stop();
        })

    }
    isDirty(): boolean {
        return JSON.stringify(this.getFields().toJson()) !== JSON.stringify(this.previousData.toJson());
    }

}